'use strict';

var Reflux   = require('reflux'),
    Promise  = require('bluebird'),
    defaults = require('superagent-defaults'),
    utils    = require('js/shared/utils/utils.js'),
    StoreActions = require('js/shared/actions/store-actions.js'),
    request  = require('superagent-promise');

var request = defaults(request);

request.set('X-Requested-With', 'XMLHttpRequest')
       .type('application/json')
       .accept('application/json');

var UserActions = Reflux.createActions({

    loadApplication: { asyncResult: true, children: ['progressed'] },
    __authUser: { asyncResult: true, children: ['progressed'] },
    onReset: { asyncResult: true, children: ['progressed'] },
    onResetSubmit: { asyncResult: true, children: ['progressed'] },

});

// duplicate of store-actions

UserActions.loadApplication.listen(function (options) {
    this.promise(new Promise(function (resolve, reject) {
        UserActions.__authUser({
            username: options.username,
            password: options.password
        }).then(function (resp1) {
            if (resp1.body.success === false) {
                reject(resp1);
                return;
            }
            else {
                StoreActions.loadApplication(resp1.body.token);
            }
        }).catch(function(error) {
            reject(error);
        });
    }));
});

UserActions.__authUser.listen(function (options) {
    this.promise(
        request
        .post('https://hackerapi.com/v1/auth/user')
        .send({
            username: options.username,
            password: options.password
        })
        .end());
});

UserActions.onReset.listen(function (email) {
    this.promise(request
        .post('https://hackerapi.com/v1/users/password')
        .send({
            email: email,
            callback_url: "http://hackthenorth.com/resetpassword"
        })
        .end()
    );
});

UserActions.onResetSubmit.listen(function (email, reset_token, password) {
    this.promise(request
        .put('https://hackerapi.com/v1/users/password?token=' + reset_token)
        .send({
                email: email,
                password: password
        })
        .end()
    );
});

module.exports = UserActions;



/*****************
 ** WEBPACK FOOTER
 ** ./js/shared/actions/user-actions.js
 ** module id = 250
 ** module chunks = 0 1 6 7 8 9
 **/